<template>
	<v-container fluid>
		<v-row>
			<v-col cols="12" v-if="agents.length">
				<span class="ml-2">فیلتر نماینده:</span>
				<v-btn-toggle v-model="agentFilter" dense tile outlined color="purple" class="mr-2 flex-wrap">
					<v-btn v-for="agent in agents" :key="agent.id" :value="agent.id" small>
						{{ agent.businessName }}
						<v-badge color="blue" :content="agent.id === 0 ? items.filter(x => x.agentModel).length : `تعداد: ${items.filter(x => x.agentModel && x.agentModel.id == agent.id).length}, مجموع: ${String(items.filter(x => x.agentModel && x.agentModel.id == agent.id).reduce(function (a, b) { return a + b.agentPrice }, 0)).toPriceFormat()}` || '0'" inline>
						</v-badge>
					</v-btn>
				</v-btn-toggle>
			</v-col>
			<v-col cols="11">
				<v-text-field v-model="search" append-icon="mdi-magnify" label="اطلاعات مورد نظر خود جهت جستجو وارد کنید" single-line hide-details class="mb-5" />
			</v-col>
			<v-col cols="1">
				<export-excel :items="items" :headers="headers" :fileName="excelFileName">
				</export-excel>
			</v-col>
			<v-col cols="12">
				<v-data-table :height="dataTableFixedHeight - 100" fixed-header :headers="headers" :loading="loading" :items="filteredItems" :footer-props="{ 'items-per-page-options': [5, 15, 50, 100] }" :items-per-page="50" :search="search" class="elevation-1">
					<template v-slot:item="row">
						<tr>
							<td @click="manageLoans(row.item)" style="cursor: pointer;">
								<div><small>{{ row.item.loanModel.title }}</small></div>
								<div class="grey--text"><small>شماره وام: {{ row.item.code }}</small></div>
							</td>
							<td class="text-center">
								{{ row.item.amount.toString().toPriceFormat() }}
							</td>
							<td @click="manageLoans(row.item)" style="cursor: pointer;">
								<div><small>{{ row.item.memberModel.fullName }}</small></div>
								<div class="grey--text"><small>کد ملی: {{ row.item.memberModel.nationalCode }}</small></div>
							</td>
							<td class="text-center">
								<div @click="editAgent({ id: row.item.agentModel.id })" style="cursor:pointer">
									<small>{{ row.item.agentModel.businessName }}</small>
								</div>
							</td>
							<td class="text-center">
								{{ row.item.agentDueDate_Persian.date }}
							</td>
							<td class="text-center">
								{{ row.item.agentPrice.toString().toPriceFormat() }}
							</td>
							<td class="text-center">
								{{ row.item.chargeTypeTitle || row.item.str_ChargeType }}
							</td>
							<td class="text-center">
								<div class="info--text" style="cursor: pointer;" @click="transactionList(row.item)">{{
									row.item.sumSponsorPayments.toString().toPriceFormat() }}</div>
								<div @click="edit(row.item)"><small class="secondary--text" style="cursor: pointer;">ثبت
										واریزی</small></div>
							</td>
						</tr>
					</template>
				</v-data-table>
			</v-col>
		</v-row>
		<div class="d-flex" style="position: absolute;bottom: 0;left: 0;
    left: 0;
		right: 0;
    font-size: 22px;
    background-color: rebeccapurple;
    color: #fff;
		justify-content: end;
    flex-wrap: wrap;">
			<div class="text-center px-3 py-3">
				مجموع: {{ sum.toString().toPriceFormat() }} تومان
			</div>
		</div>

		<v-dialog v-model="dialogTransaction" scrollable max-width="925px">
			<v-card>
				<v-card-title>
					<div><span class="headline"></span></div>
					<v-spacer />
					<v-btn @click="dialogTransaction = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<modify-transaction v-if="dialogTransaction" :data="selectedTransaction" @callbck="callbck_transaction" />
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogAgentTransactionsList" scrollable max-width="1200px">
			<v-card>
				<v-card-title>
					<div><span class="headline">لیست واریزی ها</span></div>
					<v-spacer />
					<v-btn @click="dialogAgentTransactionsList = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<AgentTransactions v-if="dialogAgentTransactionsList" :agent="localAgent" :userLoan="selectedUserLoan" @update="() => { loadData(); $emit('update') }" />
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogLoansManager" scrollable max-width="1200px">
			<v-card>
				<v-card-title>
					<div><span class="headline">مدیریت وام</span></div>
					<v-spacer />
					<v-btn @click="dialogLoansManager = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<manage-loan ref="manageLoan" v-if="dialogLoansManager" :data="{ member: selectedMember }" />
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogAgent" scrollable persistent max-width="700px">
			<v-card>
				<v-card-title>
					<span class="headline">مشخصات نماینده</span>
					<v-spacer />
					<v-btn @click="dialogAgent = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<ModifyAgent :data="selectedAgent" v-if="dialogAgent" @callbck="agent_callbck" />
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>
	</v-container>
</template>

<script>
import api from '@/util/app-api'
import toast from '@/util/toast'
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
import ModifyLoanPayment from '@/views/admin/ModifyLoanPayment.vue'
import { emptyId } from '@/util/emptyId'

export default {
	name: 'AgentOverDue',
	components: {
		ConfirmDlg: () => import('@/components/Confirm'),
		ModifyAgent: () => import('@/views/admin/agent/ModifyAgent'),
		AgentTransactions: () => import('@/views/admin/agent/AgentTransactions.vue'),
		'date-picker': VuePersianDatetimePicker,
		'modify-loan-payment': ModifyLoanPayment,
		'modify-transaction': () => import('@/views/admin/ModifyTransaction'),
		'manage-loan': () => import('@/views/admin/ManageLoan.vue'),
		'app-sms-detail': () => import('@/components/AppSmsDetails.vue'),
	},
	data() {
		return {
			selectedAgent: {},
			localAgent: null,
			selectedTransaction: null,
			dialogTransaction: false,
			dialogLoansManager: false,
			dialogModifyLoanPayment: false,
			dialogAgent: false,
			selectedUserLoan: null,
			selectedMember: {},
			dialogAgentTransactionsList: false,
			selectedLoanPayment: null,
			errorMessages: '',
			search: '',
			loading: false,
			sum: 0,
			sumByDelays: 0,
			agentFilter: '',
			agents: [],
			items: [],
			headers: [
				{
					text: 'مشخصات وام',
					align: 'start',
					sortable: true,
					value: 'loanModel.title',
				}, {
					text: 'مبلغ وام',
					align: 'center',
					sortable: true,
					value: 'amount',
				}, {
					text: 'مشخصات مشتری',
					align: 'start',
					sortable: true,
					value: 'memberModel.fullName',
				}, {
					text: 'کد ملی',
					align: 'center d-none',
					sortable: true,
					value: 'memberModel.nationalCode',
				}, {
					text: 'نماینده',
					align: 'center',
					sortable: true,
					value: 'agentModel.businessName',
				}, {
					text: 'سررسید واریز نماینده',
					align: 'center',
					sortable: true,
					value: 'agentDueDate_Persian',
					excel_value: 'agentDueDate_Persian.date',
				}, {
					text: 'سهم نماینده',
					align: 'center',
					sortable: true,
					value: 'agentPrice',
					width: 200
				}, {
					text: 'نحوه دریافت',
					align: 'center',
					sortable: true,
					value: 'str_ChargeType',
					width: 120
				}, {
					text: 'مجموع واریز اسپانسر',
					align: 'center',
					sortable: false,
					value: 'sumSponsorPayments'
				}
			]
		}
	},
	computed: {
		excelFileName() {
			let name = 'لیست سررسید های نماینده ها'
			name += '.xls'
			return name
		},
		filteredItems() {
			if (!this.agentFilter)
				return this.items

			let clonedItems = []
			clonedItems.push(...this.items)

			clonedItems = clonedItems.filter(x => x.agentModel && x.agentModel.id == this.agentFilter)

			return clonedItems
		}
	},
	mounted() {
		this.loadData()
	},
	methods: {
		loadData() {
			this.loading = true
			api.get('admin/UserLoan/AgentsOverDueList', {})
				.then(
					response => {
						this.items = response
						if (response.length)
							this.sum = response.map(x => x.agentPrice).reduce((prev, next) => {
								return prev + next
							})
						else
							this.sum = 0
						this.agents = Object.values(
							response.reduce((acc, obj) => ({ ...acc, [obj.agentModel.id]: obj.agentModel }), {})
						)
						if (this.agents.length) {
							this.agents.push({ id: 0, businessName: 'همه' })
						}
					})
				.catch(err => {
					toast.error(err.message)
				})
				.finally(x => { this.loading = false })
		},
		manageLoans(item) {
			this.selectedMember = { id: item.memberModel.id, fullName: item.memberModel.fullName, nationalCode: item.memberModel.nationalCode, mobile: item.memberModel.mobile }
			this.dialogLoansManager = true
		},
		edit(item) {
			this.selectedTransaction = {
				id: emptyId,
				paymentMethod: 2,
				isWithdraw: true,
				agent: {
					id: item.agentModel.id,
					businessName: item.agentModel.businessName,
					mobile: item.agentModel.mobile,
					firstName: item.agentModel.firstName,
					bankAccountsJson: item.agentModel.bankAccountsJson
				},
				userLoan: {
					id: item.id,
					title: `شماره وام: ${item.code}, عنوان: ${item.loanModel.title}`,
					code: item.code
				},
				amount: Math.max(item.agentPrice - item.sumSponsorPayments, 0),
				maxAmount: item.agentPrice - item.sumSponsorPayments,
				userLoanRequest: { id: item.userLoanRequest.id },
				agentStatus: item.userLoanRequest.agentStatus,
				customerStatus: item.userLoanRequest.status,
			}
			console.log("🚀 ~ edit ~ item.userLoanRequest:", item.userLoanRequest)
			this.dialogTransaction = true
		},
		callbck_transaction(result) {
			this.dialogTransaction = false
			if (result)
				this.loadData()
		},
		transactionList(userLoan) {
			if (userLoan.agentModel)
				this.localAgent = userLoan.agentModel
			this.selectedUserLoan = userLoan
			this.dialogAgentTransactionsList = true
		},
		editAgent(agent) {
			if (!agent?.id)
				return
			this.selectedAgent = agent
			this.dialogAgent = true
		},
		agent_callbck(result) {
			this.dialogAgent = false
		},
	},
}
</script>
<style></style>
